// When a rental's next factura is due — the "Facturar" column of the rental lists (which replaced "Fin": Intmed's rentals
// never have an end date). The same rule as backend/services/rentalSchedule.js: the next charge is the start date for a
// contrato generado and the next recharge for an active rental; a period starting on or after an end date isn't charged;
// a borrador, a returned or a cancelled rental has none.
import { todayDR } from './dates';

const day = (d) => (d ? String(d).slice(0, 10) : null);

// "YYYY-MM-DD" or null.
export const nextBillingDate = (r) => {
  const next = day(r.status === 'contract_generated' ? r.startDate : r.status === 'active' ? r.nextRechargeDate : null);
  if (!next) return null;
  const end = day(r.endDate);
  return end && next >= end ? null : next;
};

const SOON_DAYS = 3; // "en N días" from this many days before

// The note under the date: { text, color } or null — "hoy", "en N días" (up to SOON_DAYS before), "atrasado N días".
export const billingNote = (ymd) => {
  if (!ymd) return null;
  const days = Math.round((Date.parse(`${ymd}T00:00:00Z`) - Date.parse(`${todayDR()}T00:00:00Z`)) / 86400000);
  if (days === 0) return { text: 'hoy', color: 'var(--mm-yellow)' };
  if (days > 0) return days <= SOON_DAYS ? { text: `en ${days} ${days === 1 ? 'día' : 'días'}`, color: 'var(--mm-cyan)' } : null;
  return { text: `atrasado ${-days} ${days === -1 ? 'día' : 'días'}`, color: '#FCA5A5' };
};
